<style lang="less" scoped>
 .contian {
     // border: solid 1px rgba(134, 134, 134,0.3);
     border-radius: 2px;
     width:100%
 }
 .echarts-contain {
     margin-top: 10px;
     width: 100%;
     height: 100%;
     padding: 10px;
 }
</style>
<template>
  <div>
    <Spin
      v-if="loading.getOverviewDataLoading"
      size="large"
      fix
    />
    <div style="text-align:right">
      <IconMark />
      <RadioGroup
        v-model="selectedChart"
        type="button"
        style="width:200px;padding:10px 10px;"
        @on-change="changeRadio"
      >
        <Radio label="每日数额" />
        <Radio label="累计数额" />
      </RadioGroup>
      <Select
        v-model="selected"
        style="width:200px;padding:10px 0;"
        @on-change="changeItem"
      >
        <Option
          v-for="item in teamsList"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </Option>
      </Select>      
    </div>

    <div class="contian">
      <OverviewTabs 
        ref="overviewTabs"
        :source-data="overviewData"
        @changeSelected="changeTable"
      /> 
      <div :style="{height:overview_height+'px'}">
        <div
          ref="echarts-contain"
          class="echarts-contain"
        />
      </div>
      <div style="margin:10px">
        <Absolute 
          ref="echarts-absolute"
          :source-data="overviewData"
          :root-teams-hash="rootTeamsHash"
        />
      </div>      
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import OverviewTabs from './OverviewTabs'
  import Absolute from './Absolute'
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
  import { setBarParams } from './over_vivew_utils'
  import { over_view_option_fun, BUTTON_FIELDS, daily_title_hash, daily_chart_legend, acc_chart_legend, acc_title_hash } from './overview_fields'
  import { NAME_SPACE } from './../constants'
  import IconMark from './IconMark.vue'
  export default {
    components: { OverviewTabs, Absolute, IconMark },
    props: {
      rootTeamsHash: {
        type: Object,
        default: () => ({})
      },
      tableHeight: {
        type:Number,
        default: () => 500
      }
    },
    data() {
      this.myChart = null // echarts 容器
      this.myAccChart = null
      this.button_fields = BUTTON_FIELDS
      return {
        selected:'all',
        selectedChart: '每日数额'
        // selected: 0
      }
    },
    computed: {
      ...mapGetters({
        teams_hash: 'async/product_teams_hash',
      }),
      ...mapState(NAME_SPACE, {
        loading:'loading',
        changeTag: 'changeTag',
        overviewData: 'overviewData',
        teamList: 'teamList'
      }),
      teamsList() {
        const item = {
          name:'集团整体',
          id: 'all'
        }
        return [item, ...this.teamList]
      },
      overview_height() {
        return this.tableHeight - 175
      }
    },
    watch:{
      'changeTag.overviewChangeIndex'() {
        this.$nextTick(() => {
          this.setChartOption()
        })
      },
    },
    mounted() {
      this.myChart = echarts.init(this.$refs['echarts-contain'], 'walden')
      this.addEchartsResize([this.myChart.resize, ...this.$refs['echarts-absolute'].getResize()]) // 将所有的echart调整注入队列中
      this.setChartOption()
    },
    methods:{
      changeItem() {
        this.getData()
      },
      changeRadio() {
        this.setChartOption()
      },
      getData() {
        const params = {}
        if (this.selected !== 'all') {
          params.team_id = this.selected
        }
        this.getOverviewData(params)
      },
      changeTable() {
        this.setChartOption()
      },
      setChartOption() {
        if (!this.overviewData) {
          return 
        }
        // let setParams = null
        let chart_legend_hash = null
        let legend_data = null
        let params = null
        let title_hash = null
        let type = null
        if (this.selectedChart === '每日数额') {
          chart_legend_hash = daily_chart_legend
          // setParams = setBarParams
          title_hash = daily_title_hash
          type = 1
        } 
        if (this.selectedChart === '累计数额') {
          chart_legend_hash = acc_chart_legend // TODO
          title_hash = acc_title_hash // TODO
          type = 2
          // setParams = setBarParams
        }
        const select = this.$refs.overviewTabs.selected
        legend_data = chart_legend_hash[select]
        switch (select) {
        case 0: // 现金收入
          params = setBarParams({
            type,
            legend_data,
            sourceData: this.overviewData.income
          })
          break;
        case 1: // 用户数
          params = setBarParams({
            type,
            legend_data,
            sourceData: this.overviewData.user
          })
          break;
        case 2:
          params = setBarParams({
            type,
            legend_data,
            sourceData: this.overviewData.new_user
          })
          break;
        case 3:
          params = setBarParams({
            type,
            legend_data,
            sourceData: this.overviewData.old_user
          })
          break;  
        case 4:
          params = setBarParams({
            type:1,
            legend_data,
            sourceData: this.overviewData.unit_price
          })
          break;                                    
        default:
          break;
        }
        const option = over_view_option_fun()
        option.legend.data = legend_data
        option.title.text = title_hash[select]
        // 
        option.xAxis[0].data = params.xAxis_data
        option.series = select !== 4 ? params.series : params.series.map(item => {
          item.data = item.data.map(num => num.toFixed(1))
          return item
        })
        if (select === 0) { // 现金收入单位处理成万
          option.series.forEach(item => {
            item.data.forEach((child, index) => {
              item.data[index] = ((child || 0) / 10000).toFixed(0) // formattingNumber(child,0,10000)
            })
          })
          option.yAxis[0].name = '单位：万'
          option.yAxis[0].nameTextStyle = {
            padding: [0, 0, 0, 50]
          }
        }
        console.log('option', option)
        this.myChart.setOption(option);
        this.$refs['echarts-absolute'].set_all(select)
      },
      ...mapActions(NAME_SPACE, [
        'getOverviewData',
      ]),
      ...mapMutations(NAME_SPACE, [
        'addEchartsResize',
        'resizeCall'
      ]),
      resizeEchart() {
        this.resizeCall([this.myChart.resize, ...this.$refs['echarts-absolute'].getResize()])
      }
    },
  }
</script>
